import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { propStr } from '../../helpers/custom-prop-types';
import Layout from '../Layout';
const ForbiddenOne = (props) => {
    const { text } = props;
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx("div", Object.assign({ className: 'l-container l-contents' }, { children: _jsxs("div", Object.assign({ className: 'l-container-9' }, { children: [_jsx("h2", Object.assign({ className: 'notfound-title font-warning align-center' }, { children: "\u7533\u3057\u8A33\u3054\u3056\u3044\u307E\u305B\u3093" })), _jsx("p", Object.assign({ className: 'honbun align-center' }, { children: text })), _jsx("div", Object.assign({ className: 'align-center modal-footer' }, { children: _jsx("ul", { children: _jsx("li", { children: _jsx(Link, Object.assign({ to: '/mypage' }, { children: "\u30DE\u30A4\u30DA\u30FC\u30B8\u3078" })) }) }) }))] })) })) })));
};
ForbiddenOne.propTypes = {
    text: propStr().isRequired,
};
export default ForbiddenOne;
